import React, {useState, useEffect, useMemo} from 'react'
import { IClientsItem } from '../../../../../../modules/API/Defaults/models/customers'
import SearchFromTheList from '../../../../../../generic/customSearchComponents/SearchFromTheList'

type Props = {
  required?: boolean
  list: IClientsItem[]
  defaultID: number
  setCustomerID: (id: number) => void | React.Dispatch<React.SetStateAction<number>>
  placeholder?: string,
  markedLinePattern?: (item: IClientsItem) => boolean
}

const SearchCustomers = ({
  list, required, setCustomerID, defaultID, placeholder, markedLinePattern

}: Props) => {
  const defaultCustomer = list.filter(item => item.CustomerID === defaultID)[0]
  const [isOpenDropDown, setIsOpenDropDown] = useState<boolean>(false)
  const [selectedCustomer, setSelectedCustomer] = useState<IClientsItem | null>(defaultCustomer || null)
  const [search, setSearch] = useState<string>(() => defaultCustomer?.Customer_Name.trim() || '')

  const handleSearch = (e: string) => {
    if(e === '') {
      setSelectedCustomer(null)
      setIsOpenDropDown(false)
      setSearch('')
      setCustomerID(0)
      return
    }
    setIsOpenDropDown(true)
    setSearch(e)
  }
  const handleSelect = (item: IClientsItem) => {
    setSearch(item.Customer_Name.trim())
    setSelectedCustomer(item)
    setIsOpenDropDown(false)
    setCustomerID(item.CustomerID)
  }
  const render = useMemo(() => {
    if(!list) return []
    return list.filter(item => 
      item.Customer_Name.trim().toLocaleLowerCase().includes(search.toLocaleLowerCase())
    )
  }, [search, list])
  return (
    <SearchFromTheList 
      isOpenList={isOpenDropDown}
      placeHolder={placeholder || 'חפש לקוח'}
      list={render}
      selectFunc={handleSelect}
      searchFunc={handleSearch}
      isNeedFullObject
      input={search}
      itemDisplayName='Customer_Name'
      nameIdElement='CustomerID'
      required={required}
      size={'full'}
      markedLinePattern={markedLinePattern}
    
    />
  )
}

export default SearchCustomers


